// import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { ThreeDots } from 'assets/assetsV1/iconComponents';

import { Menu } from 'uiToolkitV1/Menu';

const RotateThreeDots = (props) => <ThreeDots sx={{ transform: 'rotate(90deg)' }} boxSize="24px" {...props} />;

const TemplateMenu = ({ menuOptions, usePortal = true }) => (
  <Menu menuList={menuOptions} MenuIcon={RotateThreeDots} usePortal={usePortal} />
  // <Menu>
  //   <MenuButton
  //     as={Button}
  //     style={{ width: '12px', paddingLeft: '0.5rem', backgroundColor: 'transparent' }}
  //     rightIcon={<ThreeDots sx={{ transform: 'rotate(90deg)' }} boxSize="24px" />}
  //   ></MenuButton>
  //   <MenuList>
  //     {menuOptions.map((menu, index) => {
  //       return (
  //         <MenuItem key={index} onClick={menu.onClick}>
  //           {menu.name}
  //         </MenuItem>
  //       );
  //     })}
  //   </MenuList>
  // </Menu>
);

export default TemplateMenu;
